import React, { forwardRef } from 'react'

import type { SlideProps } from '@mui/material/Slide'
import Slide from '@mui/material/Slide'

const Transition = forwardRef<unknown, SlideProps>((props, ref) => <Slide direction="up" ref={ref} {...props} />)

export default Transition
